const QuotesConstants = {
  initialMSPlanSortOption: 'Primary Monthly Premium',
  initialMAPlanSortOption: 'Primary Estimated Annual Cost',
  initialMPartDPlanSortOption: 'Popularity',
}

export default QuotesConstants
